import React, { useContext, useEffect, useRef } from 'react';
import { DashboardContext } from '../Context/contexts/DashboardContext';
import defaults from '../../translations/en.json';

type ErrorProps = {
  resetError: () => void;
};

/** Fallback UI only — never mounts the failed widget tree. */
export const Error = ({ resetError }: ErrorProps) => {
  const { refreshDashboard } = useContext(DashboardContext);
  const prevRefresh = useRef(refreshDashboard);

  useEffect(() => {
    if (refreshDashboard > prevRefresh.current) {
      resetError();
    }
    prevRefresh.current = refreshDashboard;
  }, [refreshDashboard, resetError]);

  return <p>{defaults.errorDisplayingWidget}</p>;
};
